// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../../library/network/CrmNetwork.bs.js";
import * as Json_encode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as TerminationRepoConfig from "./TerminationRepoConfig.bs.js";
import * as CommonRepoConfig$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/CommonRepoConfig.bs.js";
import * as PostRequestHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/PostRequestHelper.bs.js";

function fetchTerminationInfo(msisdn, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/get_termination_info?msisdn=" + msisdn);
  return CrmNetwork.get(requestUrl, undefined, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TerminationRepoConfig.TerminationInfoResponseConverter.execute, result);
                        });
            });
}

function fetchTerminationReasons(country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/get_termination_reasons";
  return CrmNetwork.get(requestUrl, undefined, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(TerminationRepoConfig.TerminationReasonsResponseConverter.execute, result);
                        });
            });
}

function terminateDriver(msisdn, reason, comment, country) {
  var payloadString = JSON.stringify(Json_encode.object_({
            hd: [
              "msisdn",
              msisdn
            ],
            tl: {
              hd: [
                "termination_reason",
                reason
              ],
              tl: {
                hd: [
                  "termination_comment",
                  comment
                ],
                tl: /* [] */0
              }
            }
          }));
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/delete_driver";
  return CrmNetwork.postRequestV2(requestUrl, undefined, payloadString, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CommonRepoConfig$Catalyst.PostApiResponseConverter.execute, result);
                        });
            });
}

function reactivateDriver(msisdn, country) {
  var payloadString = PostRequestHelper$Catalyst.getPostRequestPayload({
        hd: {
          name: "msisdn",
          value: msisdn
        },
        tl: /* [] */0
      });
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/reactivate_driver";
  return CrmNetwork.postRequestV2(requestUrl, undefined, payloadString, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CommonRepoConfig$Catalyst.PostApiResponseConverter.execute, result);
                        });
            });
}

var TerminationRepo = {
  fetchTerminationInfo: fetchTerminationInfo,
  fetchTerminationReasons: fetchTerminationReasons,
  terminateDriver: terminateDriver,
  reactivateDriver: reactivateDriver
};

export {
  TerminationRepo ,
  
}
/* Config Not a pure module */
